export const tableStyleConfig = {
  spacing: {
    none: '',
    small: 'p-1 px-3',
    medium: 'p-2 px-4',
    large: 'p-3 px-5',
  },

  rowDivisor: {
    none: '',
    all: 'border-b',
    'header-only': '[thead>&]:border-b [thead>&]:border-b-muted',
    'skip-header': 'border-b border-b-muted [thead>&]:border-none',
    'skip-last': 'border-b border-b-muted [tbody>&:last-child]:border-none',
    'skip-header-and-last':
      'border-b border-b-muted [thead>&]:border-none [tbody>&:last-child]:border-none',
  },
} as const;

type StyleRef = typeof tableStyleConfig;

export interface TableStyleProps {
  /**
   * How much each cell should space out each other
   * Default is `medium`
   */
  spacing?: keyof StyleRef['spacing'];

  /**
   * Row divisor configuration
   * Default is `skip-header-and-last`
   * - `all`: every single row has a border bottom
   * - `header-only`: Only the header row
   * - `skip-header`: header row does not get a border
   * - `skip-last`: last row does not get a border
   * - `skip-header-and-last`: as the name implies
   * - `none`: as the name implies
   * You may also use `rowClassName` to fine tune your needs
   */
  rowDivisor?: keyof StyleRef['rowDivisor'];
}
